import { Outlet } from 'react-router-dom';

const UserManagementLayout = () => <Outlet />;

export default UserManagementLayout;
